//import axios from 'axios';
import api from '@/libs/axios'
//import process from 'node';
//import process from 'node:process';

export interface schBForm{
    address : string;
    municipality : string;
    date : string

}

//const apikey = import.meta.env.VITE_API_KEY;

export function usePdfDownloader() {

    /**
     * This will simulate a download via anchor tag in the browser
     * @param pdfBlob 
     * @param filename 
     */
    async function downloadPdf(pdfBlob : Blob, filename : string){
        console.log('invoice form download PDF...')

        //download the blob data
        // const CSVFile = new Blob([csvData2], { type: 'text/csv' });
        // Create to temporary link to initiate
        // download process
        let temp_link = document.createElement('a')

        // Download csv file
        temp_link.download = filename
        let url = window.URL.createObjectURL(pdfBlob)
        temp_link.href = url

        // This link should not be displayed
        temp_link.style.display = 'none'
        document.body.appendChild(temp_link)

        // Automatically click the link to trigger download
        temp_link.click()
        document.body.removeChild(temp_link)
    }


    /**
     * post and download a filled pdf form for schB screwpiles with geotech
     */
    async function downloadSchBPdf(obj : schBForm, filename : string){
    console.log("testing getSchB Pdf from microservice...");
    //const obj = { address : '99 someplace', municipality : 'municipality1', date : formatDate(new Date())}
   /// console.log("..testing vue app.apikey from process.env :" + apikey); //process.env.VUE_APP_API_KEY);
    
   /* axios({
       //url: 'http://localhost:8080/pdf/schB', //your url
        url: '/pdf/schB', //your url
        method: 'POST',
        data: obj,
        responseType: 'blob', // important
        headers: {
            'apikey' : apiKey
        }*/
    api.post('/pdf/schB',obj, {responseType : 'blob'}
    ).then((response) => {
        console.log('response : ', JSON.stringify(response));
        // create file link in browser's memory
        const href = URL.createObjectURL(response.data);

        // create "a" HTML element with href to file & click
        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', filename); //or any other extension
        document.body.appendChild(link);
        link.click();

        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
    });




}


 

    return { downloadPdf, downloadSchBPdf }
}